module.exports = __webpack_public_path__ + "static/media/mana_bar_bg.d3b33485.png";